import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SynCardComponent } from '@synergy-design-system/angular';

@Component({
  selector: 'app-overview',
  template: `
    <div class="flex-row flex-wrap gap-1">
      <syn-card>
        <h3 i18n="@@manage-customers">Manage Customer Accounts</h3>
        <span i18n="@@overview.manage-customers.description">
          Manage accounts for your customers:
          <ul>
            <li>Create, edit or activate customer accounts</li>
            <li>Search and export customer accounts</li>
          </ul>
        </span>

        <footer slot="footer">
          <nav>
            <syn-button
              variant="filled"
              size="small"
              i18n="@@overview.manage-customers.open"
              routerLink="/customers"
            >
              Manage Customers
            </syn-button>
          </nav>
        </footer>
      </syn-card>

      <syn-card>
        <h3 i18n="@@overview.manage-clients.title">Manage My SICK ID Clients</h3>
        <span i18n="@@overview.manage-clients.description">
          Manage your SICK ID clients:
          <ul>
            <li>Create or edit clients</li>
            <li>Create or assign roles</li>
          </ul>
        </span>

        <footer slot="footer">
          <nav>
            <syn-button
              variant="filled"
              size="small"
              i18n="@@overview.manage-clients.open"
              routerLink="/clients"
            >
              Manage Clients
            </syn-button>
          </nav>
        </footer>
      </syn-card>

      <syn-card>
        <h3 i18n="@@overview.manage-test-users.title">Manage Test Users</h3>
        <span i18n="@@overview.manage-test-users.description">
          Manage your SICK ID test users:
          <ul>
            <li>Test common and edge cases in your application</li>
            <li>Create users and freely edit their attributes</li>
          </ul>
        </span>

        <footer slot="footer">
          <nav>
            <syn-button
              variant="filled"
              size="small"
              i18n="@@overview.manage-test-users.open"
              routerLink="/test-users"
            >
              Manage Test Users
            </syn-button>
          </nav>
        </footer>
      </syn-card>

      <syn-card>
        <h3 i18n="@@overview.client-list.title">List SICK ID Clients</h3>
        <span i18n="@@overview.client-list.description">
          Get an overview of the different SICK ID clients.
        </span>

        <footer slot="footer">
          <nav>
            <syn-button
              variant="filled"
              size="small"
              i18n="@@overview.client-list.open"
              routerLink="/client-list"
            >
              List Clients
            </syn-button>
          </nav>
        </footer>
      </syn-card>

    </div>
  `,
  styles: [
    `
      syn-card {
        width: 22em;
        min-width: 22em;
      }

      syn-card::part(body) {
        height: 15em;
      }
    `,
  ],
  imports: [RouterLink, SynCardComponent],
})
export class OverviewComponent {
  year = new Date().getFullYear();
}
